import React, {FC} from "react";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb} from "antd";
import DtoTable from "../../components/dto-table/dto-table";
import DmcControlReadingsModel from "../../models/dto/dmccontrolreadings-model";

const DmcControlReadingsScreen: FC = () => {

    const [trigger, setTrigger] = useSafeState(false);

    return (<>

            <>

                <Breadcrumb style={{marginBottom: 10}}>
                    <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
                    <Breadcrumb.Item><Trans id={'DmcControlReadings'}></Trans></Breadcrumb.Item>
                </Breadcrumb>
                <DtoTable
                    model={DmcControlReadingsModel}
                    trigger={trigger}
                    allowExport={true}
                    allowRefreshButton={true}
                    apiUrl={"dmc-control-readings"}
                    pageSize={100}
                    scroll={{x: 1300, y: "65vh"}}/>
            </>
        </>
    )
}
export default DmcControlReadingsScreen;
